import { jsx as _jsx } from "react/jsx-runtime";
import { Box, EmptyState } from '@dixa/lib-shared-habla';
export const AnalyticsFilterLayoutEmpty = () => (_jsx(Box, Object.assign({ as: "li", padding: "250 300" }, { children: _jsx(EmptyState, { title: "No items found", description: "Try changing your search criteria." }) })));
